import { Box, IconButton, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { RightIcon } from '../../../../assets/Svg/Index'
import { noop } from '../../../../helpers/utils'
import CustomDialog from '../../../common/CustomDialog'

const SurveyConfirmationModal = ({ onClose, open }) => {
  const { t } = useTranslation()
  return (
    <CustomDialog
      className="custom-dialog"
      close={onClose}
      aria-labelledby="thankyou-survey-popup"
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <Box p={3}>
        {onClose ? (
          <IconButton
            size="small"
            tabIndex={-1}
            aria-label="close"
            className="close-button"
            onClick={onClose}
          >
            <X />
          </IconButton>
        ) : null}
        <Box display={'flex'} justifyContent={'center'}>
          <RightIcon />
        </Box>
        <Box mt={3} display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <Typography variant="h3">
            <Box fontWeight={600} textAlign={'center'} maxWidth={'350px'} fontSize={'26px'}>
              {t('surveySubmittedSuccessfully')}
            </Box>
          </Typography>

          <Typography variant="h5">
            <Box
              maxWidth={'550px'}
              color={'var(--color-grey-3)'}
              mt={3}
              fontWeight={500}
              fontSize={'16px'}
              textAlign={'center'}
            >
              {t('thankYouForFillingSurvey')}
            </Box>
          </Typography>
        </Box>
      </Box>
    </CustomDialog>
  )
}

SurveyConfirmationModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
}

SurveyConfirmationModal.defaultProps = {
  onClose: noop,
  open: false,
}

export default SurveyConfirmationModal
